/*

Scroll into view

*/


function initialise(context) {
    // Get element id.
    const scrollElementId = context.attr(expressSelectors()['axis-scroll-into-view']['initialise']);
    // Find element.
    let scrollElement = (scrollElementId ? $('#' + scrollElementId) : context);
    const scroll = doScroll(scrollElement);
    return scroll; 
}

function doScroll(scrollElement) {
    const scroll = scrollIntoView(scrollElement, {
        force: true
    });
    return scroll;
}

var component = {
    initialise: (context) => {
        return initialise(context);
    },
    scroll: (context) => {
        return doScroll(context);
    }
}
export { component };